<template>
    <!-- Barras horizontales: cantidad y % de cada categoría. Si `filtro` viene,
         cada fila es un botón que aplica ese filtro global (ver el detalle). -->
    <div class="es-bars">
        <template v-if="items.length">
            <!-- Fila tipo "bar list": la barra va detrás del nombre (misma celda
                 de la grilla) y la cifra + % en una columna alineada a la derecha.
                 La categoría más grande se resalta. -->
            <component :is="filtro ? 'button' : 'div'" v-for="it in mostrados" :key="it.k" :type="filtro ? 'button' : null" class="es-bar"
                       :class="{ 'is-max': esMax(it) }"
                       :title="filtro ? 'Filtrar por ' + it.t : (it.d || null)" @click="filtro && $emit('filtrar', it.k)">
                <span class="es-bar-track" aria-hidden="true"><span class="es-bar-fill" :style="{ width: ancho(it) }"></span></span>
                <span class="es-bar-t">{{ it.t }}<small v-if="it.extra">{{ it.extra }}</small><em v-if="it.verificada === false">sin verificar</em></span>
                <span class="es-bar-n"><b>{{ cifra(it.n) }}</b><small>{{ fmtPct(it.pct) }}</small></span>
                <span v-if="it.d && conDesc" class="es-bar-d">{{ it.d }}</span>
            </component>
            <button v-if="items.length > limite" type="button" class="es-mas" @click="todo = !todo">{{ todo ? 'Ver menos' : 'Ver las ' + items.length }}</button>
        </template>
        <p v-else class="es-vacio">Sin datos con estos filtros.</p>
        <div v-if="aparteLista.length" class="es-aparte">
            <span v-for="a in aparteLista" :key="a.t" :title="a.d || null">{{ a.t }} <b>{{ cifra(a.n) }}</b></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EstBarras',
    props: {
        items: { type: Array, default: () => [] },
        limite: { type: Number, default: 8 },
        filtro: { type: Boolean, default: false },
        conDesc: { type: Boolean, default: false },
        aparte: { type: Array, default: () => [] },
    },
    data() { return { todo: false }; },
    computed: {
        mostrados() { return this.todo ? this.items : this.items.slice(0, this.limite); },
        max() { return Math.max(1, ...this.items.map(i => i.n)); },
        aparteLista() { return this.aparte.filter(a => a.n > 0); },
    },
    methods: {
        cifra(n) { return Number(n || 0).toLocaleString('es-CL'); },
        fmtPct(p) { return Number(p || 0).toLocaleString('es-CL', { maximumFractionDigits: 1 }) + '%'; },
        esMax(it) { return it.n > 0 && it.n === this.max; },
        ancho(it) { return Math.max(it.n ? 2 : 0, Math.round(it.n * 100 / this.max)) + '%'; },
    },
};
</script>
